import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { BrandFavorite } from './BrandFavorite';
import { FirstRowProps } from './utils/types';
import { ProductDetailScreenStyles } from '../ProductDetailScreenStyles';

const FavoriteBrand = ({ brand, isLoadingBrandInfo, userId }: FirstRowProps) => {
    if (!userId) {
        return null;
    }

    return !isLoadingBrandInfo && brand ? (
        <div>
            <BrandFavorite brandId={`${brand.id}`} brandName={brand.name} />
        </div>
    ) : (
        <Skeleton style={{ width: '100%', height: '12px', minWidth: '100%' }} />
    );
};

export const FirstRow = ({ brand, isLoadingBrandInfo, userId }: FirstRowProps) => {
    return (
        <div className="flex w-full">
            <div>
                <div className=" w-24 sm:w-36 h-24 sm:h-36 p-1 text-center border border-grey-light rounded-xl flex items-center align-center justify-center">
                    {brand && <img src={brand.imageUrl} />}
                </div>
            </div>
            <div className="flex flex-col w-4/6 sm:w-4/5 items-top align-top ml-4 sm:mt-0 mb-auto">
                <FavoriteBrand
                    brand={brand}
                    isLoadingBrandInfo={isLoadingBrandInfo}
                    userId={userId}
                />
                {brand && <h1 className={`${ProductDetailScreenStyles.title}`}>{brand.name}</h1>}
            </div>
        </div>
    );
};
